<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title"
                     v-t="{ path: 'message.title_add_object', args: { objectName: linkDescription } }">
                </div>
                <hr class="dialog-hr">
                <el-form label-width="200px" @submit.native.prevent="saveLinkTenant()">
                    <div class="confirm-body">
                        <el-form-item prop="tenantName" ref="tenantName">
                            <div slot="label" style="text-align:left" v-t="'message.item_tenant_name'"></div>
                            <el-input
                                id="tenantName"
                                v-model="inputForm.tenantName.value"
                                type="text"
                                clearable
                                @compositionstart.native="compositionStart($event.target.id)"
                                @compositionend.native="compositionEnd($event.target.id)"
                                @input.native="inputCheck($event.target.id)"
                                @clear="InputCheckAll()"
                            ></el-input>
                        </el-form-item>
                        <div class="terms-of-c2c-feature">
                            <div v-if="this.inputForm.linkType" v-t="'message.info_allow_request_note'"></div>
                            <div
                                v-if="this.inputForm.linkType"
                                class="terms-of-c2c-feature__note2"
                            >
                                <p v-t="'message.info_allow_request_note2'"></p>
                                <div class="terms-of-c2c-feature__list">
                                    <p
                                        class="terms-of-c2c-feature__list-item"
                                    >
                                        ・{{ $t("message.info_allow_request_note2_list_item_1") }}
                                    </p>
                                    <p
                                        class="terms-of-c2c-feature__list-item"
                                    >
                                        ・{{ $t("message.info_allow_request_note2_list_item_2") }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="dialog-hr">
                    <div class="dialog-button-field">
                        <el-button class="dialog-cancel-button" @click="$emit('cancel')"
                                   v-t="'message.button_cancel'"></el-button>
                        <el-button class="dialog-ok-button" :disabled="disableSave" native-type="submit"
                                   v-t="'message.button_save'"></el-button>
                    </div>
                </el-form>
            </div>
        </div>
    </transition>
</template>

<script>
import server from "@/components/ServerApi.js";
import commonUtil from '@/components/commonutil.js';
import constants from '@/components/constants.js';
import commonValidate from '@/components/common-validate.js';

export default {
    emits: ["save", "cancel"],
    props: ['appData', 'linkType'],
    data() {
        return {
            disableSave: true,
            linkDescription: null,
            inputForm: {
                tenantName: {validationRule: "domainName", value: null, isComposing: false},
                linkType: 0,
            },
        };
    },
    created: function () {
        this.inputForm.linkType = this.linkType;
        if (this.linkType === constants.TENANT_CONNECT_WANT) {
            this.linkDescription = commonUtil.getMessageText(this.$i18n, 'title_desc_link_tenant1');
        } else {
            this.linkDescription = commonUtil.getMessageText(this.$i18n, 'title_desc_link_tenant2');
        }
    },
    methods: {
        inputCheck(eventTargetId) {
            if (this.inputForm[eventTargetId].isComposing) {
                // inputting with IME
                return;
            }
            const validateResult = commonValidate.validateItem(
                this.$i18n,
                this.inputForm[eventTargetId].validationRule,
                this.inputForm[eventTargetId].value
            );
            if (validateResult.valid) {
                if (this.inputForm[eventTargetId].value === this.appData.tenantList[0].name) {
                    this.$refs[eventTargetId].validateState = "error";
                    this.$refs[eventTargetId].validateMessage = commonUtil.getMessageText(this.$i18n, "error_cannot_use_own_tenant");
                    this.disableSave = true;
                } else {
                    this.$refs[eventTargetId].clearValidate();
                    this.disableSave = false;
                }
            } else {
                this.$refs[eventTargetId].validateState = "error";
                this.$refs[eventTargetId].validateMessage = validateResult.message;
                this.disableSave = true;
            }
        },
        compositionStart(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = true;
        },
        compositionEnd(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = false;
            this.inputCheck(eventTargetId)
        },
        InputCheckAll() {
            for (let targetId in this.inputForm) {
                this.inputCheck(targetId);
            }
        },
        async saveLinkTenant() {
            try {
                const res = await server.postNoError('/checktenantname', {
                    tenantName: this.inputForm.tenantName.value
                });
                switch (res.data.status) {
                    case constants.STATUS_ERROR_NOT_FOUND:
                        this.disableSave = true;
                        this.$refs["tenantName"].validateMessage = commonUtil.getMessageText(this.$i18n, "error_link_not_found");
                        this.$refs["tenantName"].validateState = "error";
                        break;
                    case constants.STATUS_ERROR_ALREADY_EXISTED:
                        this.$emit('save', this.inputForm.linkType, this.inputForm.tenantName.value, 0);
                        break;
                    default:
                        this.$refs["tenantName"].validateMessage = commonUtil.getMessageText(this.$i18n, "error_link_api_error").replace('{status}', res.data.status);
                        this.$refs["tenantName"].validateState = "error";
                        break;
                }
            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "saveLinkTenant", e);
            }
        },
    },
}
</script>

<style scoped>
p {
    margin: 0;
}

.setting-items >>> .el-slider__button {
    width: 12px;
    height: 12px;
    background-color: #5171cb;
    border: #5171cb;
}

.setting-items >>> .el-slider__bar {
    background-color: #5171cb;
}

.terms-of-c2c-feature {
    font-size: 12px;
    color: gray;

    .terms-of-c2c-feature__note2 {
        display: flex;
        flex-direction: column;
        row-gap: 4px;
        margin-top: 8px;
    }
}
</style>
